/* eslint-disable no-undef */
// remove no-js flag
$('html').removeClass('no-js');

$(document).ready(() => {
  initMobileMenu();
  initSmallLayoutAnimations();

  // Select2
  const select2Els = document.getElementsByClassName('select2');
  if (select2Els) {
    Array.prototype.forEach.call(select2Els, (el) => {
      el.style.display = 'none';
      NiceSelect.bind(el, { searchable: false, placeholder: el.dataset.placeholder, selectedtext: '' });
    });
  }

  // Lightbox
  const lightboxEls = document.getElementsByClassName('lightbox');
  if (lightboxEls) {
    Fancybox.bind('.lightbox', {
      // l10n: Fancybox.l10n.de,
    });
  }

  // Slideshow
  const swiperEls = document.getElementsByClassName('swiper');
  if (swiperEls) {
    const swiper = new Swiper('.swiper', {
      speed: 500,
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  // Menu onClick
  const els = document.querySelectorAll('.link.subs');
  Array.prototype.forEach.call(els, (el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      if (el.classList.contains('open')) {
        el.classList.remove('open');
      } else {
        document.querySelectorAll('.link.subs.open').forEach((el) => el.classList.remove('open'));
        el.classList.add('open');
      }
    });
  });
  // eslint-disable-next-line func-names
  window.onclick = function (e) {
    if (!e.target.classList.contains('link')) {
      document.querySelectorAll('.link.subs.open').forEach((el) => el.classList.remove('open'));
    }
  };
});

if ($('.tx-str3template.plugin-services .filter-form').length > 0) {
  if ($(".filter-form input[type='submit']").length === 0) {
    $('.filter-form input, .filter-form select').on('change', () => {
      $(this).parents('form.filter-form').trigger('submit');
    });

    $(document).on('click', '.nice-select .option:not(.disabled)', function (t) {
      const s = $(this);
      const n = s.closest('.nice-select');

      n.siblings('select').val(s.data('value')).change();
      n.parents('form.filter-form').trigger('submit');
    });
  }
}

// FIX wrong 100vh in iOS and android jumps when the url bar hides
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const vh = window.innerHeight * 0.01;
// this is than used as var inside css/less
document.documentElement.style.setProperty('--vh', `${vh}px`);
